// Vivette → Klaviyo client subscription.
// Subscribes an email to a Klaviyo list via the public Client API
// (https://developers.klaviyo.com/en/reference/create_client_subscription).
// Degrades gracefully when the keys are not yet provisioned: it shows a
// friendly "being set up" message and never throws or logs an error.
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2026-04-15';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-klaviyo]');
    if (!form) return;
    e.preventDefault();

    var company = form.getAttribute('data-company');
    var listId = form.getAttribute('data-list');
    var source = form.getAttribute('data-source') || 'site';
    var msg = form.querySelector('[data-msg]');
    var input = form.querySelector('input[type=email]');
    var email = input ? input.value.trim() : '';

    var say = function (text) { if (msg) msg.textContent = text; };

    // Keys not yet provisioned — degrade gracefully, no console error.
    if (!company || !listId) {
      say('Sign-up is being set up — check back soon.');
      return;
    }

    // Basic email guard (the input is type=email + required, but we
    // submit via fetch so we validate here too rather than rely on the UA).
    if (!email) {
      say('Please enter your email address.');
      if (input) input.focus();
      return;
    }

    say('One moment…');

    fetch(ENDPOINT + encodeURIComponent(company), {
      method: 'POST',
      headers: {
        // Klaviyo's client subscription endpoint uses the JSON:API content type
        // plus a CURRENT 'revision'. A stale/sunset revision is rejected before
        // CORS headers are added — surfacing as a CORS block in the browser — so
        // keep REVISION current (developers.klaviyo.com create_client_subscription).
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    })
      .then(function (r) {
        if (r.status === 202) {
          say('Thank you! Use code GRAB10 at checkout for 10% off your first piece.');
          form.reset();
          // Phase 3 tracking hook: Meta Pixel / GA4 lead event listens here.
          document.dispatchEvent(
            new CustomEvent('vivette:lead', { detail: { source: source } })
          );
        } else {
          say('Sorry — something went wrong. Please try again.');
        }
      })
      .catch(function () {
        say('Sorry — something went wrong. Please try again.');
      });
  });
})();
